export default "__VITE_ASSET__D0Wg0RN9__"